import { useEffect, useState } from "react";
import { motion, useSpring, useTransform } from "framer-motion";

export const AnimatedNumber = ({ value, prefix = "$", className = "", ...rest }) => {
  const spring = useSpring(0, { stiffness: 70, damping: 18 });
  const display = useTransform(spring, (v) => `${prefix}${Math.round(v).toLocaleString()}`);

  useEffect(() => {
    spring.set(value);
  }, [value, spring]);

  return <motion.span {...rest} className={className}>{display}</motion.span>;
};

export const CountUp = ({ to, prefix = "", suffix = "", className = "" }) => {
  const [started, setStarted] = useState(false);
  const spring = useSpring(0, { stiffness: 50, damping: 20 });
  const display = useTransform(spring, (v) => `${prefix}${Math.round(v).toLocaleString()}${suffix}`);

  useEffect(() => {
    if (started) spring.set(to);
  }, [started, to, spring]);

  return (
    <motion.span
      className={className}
      onViewportEnter={() => setStarted(true)}
      viewport={{ once: true }}
    >
      {display}
    </motion.span>
  );
};
